import React from 'react';
import classNames from 'classnames';
import { __ } from '../../../core/utils';
import styles from '../../../styles/views/timesheets/TimesheetEntriesStatistic.scss';
import workingSetStyles from '../../../styles/views/specifications/WorkingSetSpecifications.scss';

const TimesheetEntriesStatistic = ({ statisticsData, formatMinutes }) => {
  const formatStatisticMinutes = (minutes) => {
    const formattedValue = formatMinutes(minutes);
    const [hours = '0', mins = '0'] = String(formattedValue || '0:00').split(':');

    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
  };

  const uncoveredMinutes = Number(statisticsData?.uncovered_minutes) || 0;
  const incompleteDays = Number(statisticsData?.incomplete_days) || 0;
  const loggedMinutes = Number(statisticsData?.logged_minutes) || 0;
  const expectedMinutes = Number(statisticsData?.expected_minutes) || 0;
  const workedMinutes = Number(statisticsData?.worked_minutes) || 0;
  const timeOffMinutes = Number(statisticsData?.time_off_minutes) || 0;
  const overtimeMinutes = Number(statisticsData?.overtime_minutes) || 0;
  const makeupMinutes = Number(statisticsData?.makeup_minutes) || 0;
  const makeupRequiredMinutes =
    Number(statisticsData?.makeup_required_minutes) || 0;
  const makeupRemainingMinutes =
    Number(statisticsData?.makeup_remaining_minutes) || 0;
  const billableMinutes = Number(statisticsData?.billable_minutes) || 0;
  const nonBillableMinutes = Number(statisticsData?.non_billable_minutes) || 0;

  return (
    <div className={styles.summaryGrid}>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>{__('Missing hours')}</div>
        <div className={classNames(styles.summaryValue, styles.summaryAlert)}>
          {formatStatisticMinutes(uncoveredMinutes)}
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>{__('Incomplete days')}</div>
        <div className={classNames(styles.summaryValue, styles.summaryWarn)}>
          {incompleteDays}
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>{__('Logged / Expected')}</div>
        <div className={styles.summaryValue}>
          {formatStatisticMinutes(loggedMinutes)} /{' '}
          {formatStatisticMinutes(expectedMinutes)}
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>{__('Worked / Time Off')}</div>
        <div className={styles.summaryValue}>
          {formatStatisticMinutes(workedMinutes)} /{' '}
          {formatStatisticMinutes(timeOffMinutes)}
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>{__('Overtime')}</div>
        <div className={styles.summaryValue}>
          {formatStatisticMinutes(overtimeMinutes)}
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>
          {__('Makeup required / completed')}
        </div>
        <div className={styles.summaryValue}>
          {formatStatisticMinutes(makeupRequiredMinutes)} /{' '}
          {formatStatisticMinutes(makeupMinutes)}
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>{__('Makeup remaining')}</div>
        <div
          className={classNames(
            styles.summaryValue,
            makeupRemainingMinutes > 0 && styles.summaryWarn
          )}
        >
          {formatStatisticMinutes(makeupRemainingMinutes)}
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryLabel}>
          {__('Billable / Non-billable')}
        </div>
        <div className={styles.summaryValue}>
          {formatStatisticMinutes(billableMinutes)} /{' '}
          {formatStatisticMinutes(nonBillableMinutes)}
        </div>
      </div>
      {/*
      <div className={classNames(styles.summaryCard, styles.statusCard)}>
        <div className={styles.summaryLabel}>{__('Status')}</div>
        <div
          className={classNames(workingSetStyles.balloon, styles.statusBalloon)}
        >
          {__('Draft')}
        </div>
      </div>
      */}
    </div>
  );
};

export default TimesheetEntriesStatistic;
